import { Component } from '@angular/core';

@Component({
  selector: 'app-portal-team-manager-main-page',
  templateUrl: './portal-team-manager-main-page.component.html',
  styleUrl: './portal-team-manager-main-page.component.scss',
  standalone: false
})
export class PortalTeamManagerMainPageComponent {}
